import { Inject, Injectable } from '@angular/core';

import {  HttpClient } from '@angular/common/http';

import { APP_CONFIG, AppConfig } from '../../../app/app-config.module';

import  { Connection, IAPIMethods } from '../models/connection/connection';
import { HttpConnection } from '../models/connection/http-connection';
//import { MockHttpConnection } from '../models/connection/http-connection-mock';
import { Observable } from 'rxjs';
import { SBSuiteResponse } from '../models/sbsuite-response.model';
import { SBSuiteHttpConnection } from '../models/connection/http-connection-sbsuite';


/**
 * Servicio de peticiones a la API.
 *
 * @export
 * @class RequestService
 * @implements {IAPIMethods}
 */
@Injectable()
export class RequestService implements IAPIMethods{

	/**
	 * Timeout de las peticiones.
	 *
	 * @static
	 * @memberof RequestService
	 */
	static readonly TIMEOUT = 6000;


	/**
	 * Contiene una instancia para la conexión al back-end.
	 *
	 * @private
	 * @type {Connection}
	 * @memberof RequestService
	 */
  private _connection: Connection;
  private _provaConn: SBSuiteHttpConnection;

	/**
	 * Contiene una instancia para la conexión de pruebas.
	 *
	 * @TODO: Eliminar una vez la release este lista
	 *
	 * @private
	 * @type {Connection}
	 * @memberof RequestService
	 */
	private _connectionMock: Connection;

	/**
	 * Crea una instancia de RequestService.
	 *
	 * @param {HttpClient} http //Cliente http de Angular4.
	 * @param {AppConfig} config //Token de configuración de la aplicación.
	 * @memberof RequestService
	 */
	constructor(
		public http: HttpClient,
		@Inject(APP_CONFIG) private config: AppConfig
	) {
		this.initializeConnection();
	}


	/**
	 * Inicia la instancia de conexión.
	 *
	 * @memberof RequestService
	 */
	initializeConnection(){
		this._connection = new HttpConnection(new  SBSuiteHttpConnection(this.http,{
			backEnd: this.config.backendURL,
			apiPath: this.config.apiPath,
			client: this.config.client,
			protocol: this.config.protocol
		}));
		//this._connectionMock = new HttpConnection(new  MockHttpConnection());
	}

	setToken(token: string  = ''){
		this._connection.setToken(token);
	}

	/**
	 * Devuelve la instancia de conexión.
	 *
	 * @TODO: Modificar al implementar la conexión definitiva.
	 *
	 * @private
	 * @param {boolean} [swap=false]
	 * @returns {Connection}
	 * @memberof RequestService
	 */
	private getConnection(swap: boolean = false): Connection{
		if(swap) return this._connection;
		return this._connectionMock;
	}



	/**
	 * Devuelve el tipo de conexión.
	 *
	 * @returns {string} El tipo de conexión.
	 * @memberof RequestService
	 */
	getConnType(): string{
		return this.getConnection().getType();
	}


	/* API FNs */

	/**
	 * Convierte la respuesta de la petición a la API /api/real/cambiarOperario.
	 *
	 * También añade un control de timeout.
	 *
	 * @param {string} [operator='']
	 * @returns {Observable<SBSuiteResponse>}
	 * @memberof RequestService
	 */
	cambiarOperario(operator: string = ''): Observable<SBSuiteResponse>{
		return this.getConnection(true).cambiarOperario(operator).map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);
	}

	/**
	 * Convierte la respuesta de la petición a la API /api/real/cambiarOf.
	 *
	 * También añade un control de timeout.
	 *
	 * @param {string} [mo='']
	 * @param {string} [operator='']
	 * @returns {Observable<SBSuiteResponse>}
	 * @memberof RequestService
	 */
	cambiarOf(code: string = '', operator: string = '', coord: string = ''): Observable<SBSuiteResponse>{
		return this.getConnection(true).cambiarOf(code, operator, coord).map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);	;
	}

	/**
	 * Convierte la respuesta de la petición a la API /api/real/entrarOperario.
	 *
	 * También añade un control de timeout.
	 *
	 * @param {string} [operator='']
	 * @returns {Observable<SBSuiteResponse>}
	 * @memberof RequestService
	 */
	entrarOperario(operator: string = '', coord: string = ''): Observable<SBSuiteResponse>{
		return this.getConnection(true).entrarOperario(operator, coord).map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);	;
	}

	/**
	 * Convierte la respuesta de la petición a la API /api/real/salirOperario.
	 *
	 * También añade un control de timeout.
	 *
	 * @param {string} [operator='']
	 * @returns {Observable<SBSuiteResponse>}
	 * @memberof RequestService
	 */
	salirOperario(operator: string = '', coord: string = ''): Observable<SBSuiteResponse>{
		return this.getConnection(true).salirOperario(operator, coord).map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);	;
	}

	/**
	 * Convierte la respuesta de la petición a la API /api/real/listaOfsInternas.
	 *
	 * También añade un control de timeout.
	 *
	 * @returns {Observable<SBSuiteResponse>}
	 * @memberof RequestService
	 */
	listaOfsInternas(operator: string = ''): Observable<SBSuiteResponse>{
		return this.getConnection(true).listaOfsInternas().map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);	;
	}



	/**
	 * Convierte la respuesta de la petición a la API /api/manual/getOfsOperario.
	 *
	 * También añade un control de timeout.
	 *
	 * @param {string} [operator='']
	 * @param {string} [date='']
	 * @returns {Observable<any>}
	 * @memberof RequestService
	 */
	getOfsOperario(operator: string = '', date: string = ''): Observable<any>{
        return this.getConnection(true).getOfsOperario(operator, date).map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);	;
    }

  /**
	 * Convierte la respuesta de la petición a la API /api/informe.
	 *
	 * También añade un control de timeout.
	 *
	 * @param {string} [date1='']
	 * @param {string} [date2='']
	 * @returns {Observable<any>}
	 * @memberof RequestService
	 */
	getInformeTest(date1: string = '', date2: string = ''): Observable<any>{
    //console.log(this.getConnection(true));

    return this.getConnection(true).getInformeTest(date1, date2).map(response=>{
      return new SBSuiteResponse(response);
    }).timeout(RequestService.TIMEOUT);	;


    //console.log("Request.service getInformeTest call. date1 val: " + date1);
    /*this._provaConn = new  SBSuiteHttpConnection(this.http,{
			backEnd: this.config.backendURL,
			apiPath: this.config.apiPath,
			client: this.config.client,
			protocol: this.config.protocol
		});

    return this._provaConn.getInformeTest(date1, date2).map(response=>{
       return new SBSuiteResponse(response);	});*/

  }

	/**
	 * Convierte la respuesta de la petición a la API /api/manual/getProductosOfDropdown.
	 *
	 * También añade un control de timeout.
	 *
	 * @param {string} [of='']
	 * @returns {Observable<SBSuiteResponse>}
	 * @memberof RequestService
	 */
	getProductosOfDropdown(of: string = ''): Observable<SBSuiteResponse>{
		return this.getConnection(true).getProductosOfDropdown(of).map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);	;
	}

	/**
	 * Convierte la respuesta de la petición a la API /api/manual/getOpsProdOfDropdown.
	 *
	 * También añade un control de timeout.
	 *
	 * @param {string} product
	 * @returns {Observable<any>}
	 * @memberof RequestService
	 */
	getOpsProdOfDropdown(product: string): Observable<any>{
		return this.getConnection(true).getOpsProdOfDropdown(product).map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);	;
	}

	/**
	 * Convierte la respuesta de la petición a la API /api/manual/ModHorasOpProdOf.
	 *
	 * También añade un control de timeout.
	 *
	 * @param {string} register El id del registro a modificar
	 * @param {*} clockIn Los parámetros necesarios
	 * @returns {Observable<any>}
	 * @memberof RequestService
	 */
	modHorasOpProdOf(register: string, clockIn: any): Observable<any>{
		return this.getConnection(true).modHorasOpProdOf(register, clockIn).map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);	;
	}


	/**
	 * Convierte la respuesta de la petición a la API /api/manual/AnadirHorasOpProdOf.
	 *
	 * También añade un control de timeout.
	 *
	 * @param {*} clockIn
	 * @returns {Observable<any>}
	 * @memberof RequestService
	 */
	anadirHorasOpProdOf(clockIn: any): Observable<any>{
		return this.getConnection(true).anadirHorasOpProdOf(clockIn).map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);	;
	}

	/**
	 * Convierte la respuesta de la petición a la API /api/manual/delHorasOpProdOf.
	 *
	 * También añade un control de timeout.
	 *
	 * @param {string} [register='']
	 * @returns {Observable<any>}
	 * @memberof RequestService
	 */
	delHorasOpProdOf(register: string = ''): Observable<any>{
		return this.getConnection(true).delHorasOpProdOf(register).map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);	;
	}

	/**
	 * Convierte la respuesta de la petición a la API /api/getParams.
	 *
	 * También añade un control de timeout.
	 *
	 * @returns {Observable<any>}
	 * @memberof RequestService
	 */
	getParams(): Observable<any>{
		return this.getConnection(true).getParams().map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);	;
	}

	/**
	 * Convierte la respuesta de la petición a la API /api/getLogo.
	 *
	 * También añade un control de timeout.
	 *
	 * @returns {Observable<any>}
	 * @memberof RequestService
	 */
	getLogo(): Observable<any>{
		return this.getConnection(true).getLogo().map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);	;
	}

	/**
	 * Convierte la respuesta de la petición de login.
	 *
	 * También añade un control de timeout.
	 *
	 * @returns {Observable<any>}
	 * @memberof RequestService
	 */
	login(credentials: {username:string, password:string} = {username:'',password:''}): Observable<any>{
		return this.getConnection(true).login(credentials).map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);	;
	}

	/**
	 * Convierte la respuesta de la petición de login.
	 *
	 * También añade un control de timeout.
	 *
	 * @returns {Observable<any>}
	 * @memberof RequestService
	 */
	operario(operator: string = ''): Observable<any>{
		return this.getConnection(true).operario(operator).map(response=>{
			return new SBSuiteResponse(response);
		}).timeout(RequestService.TIMEOUT);	;
	}

}



// WEBPACK FOOTER //
// ./src/modules/sbsuite/providers/request.service.ts